"use client";
import { useState } from "react";
import { useRouter } from "next/navigation";
// import "bootstrap/dist/css/bootstrap.min.css";

export default function VerifyPage() {
  const [code, setCode] = useState("");
  const router = useRouter();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.trim()) {
      router.push(`/cert/${code.trim()}`);
    }
  };

  return (

    <div className="container py-5 col-12 col-xl-8 mx-auto p-6 bg-white rounded-4 p-4  shadow-sm">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card p-4">
            <h3 className="text-start border-bottom pb-3">🔍 التحقق من شهادة</h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">كود الشهادة</label>
                <input type="text" className="form-control" value={code} onChange={(e) => setCode(e.target.value)} required />
              </div>
              <div className="d-grid">
                <button className="btn btn-primary" type="submit">
                  تحقق الآن
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  );
}
